/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./cost-estimate-update-action-body').CostEstimateUpdateActionBody} CostEstimateUpdateActionBody
 */

/**
 * @typedef {import('./cost-estimate-update-action-response').CostEstimateUpdateActionResponse} CostEstimateUpdateActionResponse
 */

/**
 * The path of the CostEstimateUpdateAction action.
 */
export const costEstimateUpdateActionPath = new SweetPath('/api/finance/cost_estimate/{cost_estimate_id}', {
  path: '{param}',
});

/**
 * Creates a contextualized CostEstimateUpdateAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createCostEstimateUpdateAction(axios) {
  /**
   * The costEstimateUpdateAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,body: CostEstimateUpdateActionBody } }
   *
   * @returns {Promise<CostEstimateUpdateActionResponse>}
   */
  function costEstimateUpdateAction({ headers = {}, parameters = {}, body } = {}) {
    const path = costEstimateUpdateActionPath.insert(parameters);

    return axios.put(path, body, { headers });
  }

  return costEstimateUpdateAction;
}
